import { v4 as uuidv4 } from 'uuid'

/**
 * genera y retorna un UUID con la libreria uuid
 * @return {string}
 */
export const generateUUID = () => uuidv4()